




import { defineComponent } from '@nuxtjs/composition-api';
import { PolicyDocument } from '@shared/ui';

export default defineComponent({
  name: 'PolicyContainer',
  components: { PolicyDocument },
  props: {
    id: {
      type: String,
      default: '',
    },
    noticeUrl: {
      type: String,
      default: '',
    },
  },
});
